import React, { useState } from 'react';
import { Card, Divider, Typography } from '@mui/material';
import { Site as SiteModel } from '@juno/client-api/model';
import { EditHeaderForm, SiteDesignPanel } from '@juno/modules';
import { Container, NavigationBlockerDialog } from '@juno/ui';
import { useSettings } from '@juno/utils';
import Embed from './Embed';
import TermsOfUseForm from './TermsOfUseForm';

interface AppearanceProps {
  site: SiteModel;
}

const General: React.FC<AppearanceProps> = ({ site }) => {
  const { configs } = useSettings();
  const [brandingFormUnsaved, setBrandingFormUnsaved] = useState(false);
  const [themeFormUnsaved, setThemeFormUnsaved] = useState(false);
  const [touFormUnsaved, setTouFormUnsaved] = useState(false);
  const [embedFormUnsaved, setEmbedFormUnsaved] = useState(false);

  const showNavigationBlockerDialog =
    brandingFormUnsaved || themeFormUnsaved || touFormUnsaved || embedFormUnsaved;

  return (
    <Container>
      <NavigationBlockerDialog when={showNavigationBlockerDialog} />
      <Card sx={{ p: 2 }}>
        <Typography variant='h5' sx={{ mb: 0 }}>
          Branding
        </Typography>
        <Divider sx={{ my: 2, mx: -0, mb: 4 }} />
        <EditHeaderForm
          siteId={site.id}
          configs={configs || []}
          setUnsavedChanges={setBrandingFormUnsaved}
        />
      </Card>
      <Card sx={{ p: 2, mt: 3 }}>
        <Typography variant='h5' sx={{ mb: 0 }}>
          Theme
        </Typography>
        <Divider sx={{ my: 2, mx: -0, mb: 4 }} />
        <SiteDesignPanel site={site} configs={configs} setUnsavedChanges={setThemeFormUnsaved} />
      </Card>
      <TermsOfUseForm setUnsavedChanges={setTouFormUnsaved} />
      <Embed setUnsavedChanges={setEmbedFormUnsaved} />
    </Container>
  );
};

export default General;
